import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import { GetCostDetailsResponseType } from "api/response";
import { CostDetailCharge } from "api/models";
import { formatPriceV2 } from "helpers/commonHelpers";

interface PostBookingConstDetailsProps {
  costDetailsData?: GetCostDetailsResponseType;
}

function PostBookingConstDetails({ costDetailsData }: PostBookingConstDetailsProps) {
  const { post_booking_in_transit_costs_data }: any = costDetailsData?.costs ?? {};
  const {
    "Origin Charges": originCharges,
    Freight: freightCharges,
    "Destination Charges": destinationCharges,
  } = post_booking_in_transit_costs_data ?? {};
  const postBookingCharges = [...(originCharges ?? []), ...(freightCharges ?? []), ...(destinationCharges ?? [])];
  if (!postBookingCharges || postBookingCharges.length === 0) return null;
  return (
    <>
      <thead className="m">
        <tr className="cost-details__header font-b4 text-secondary">
          <td className="cost-details__header-charge">
            <FormattedMessage id="quote-request.postBookingCharges" defaultMessage="Total approved post booking charges" />
          </td>
          <td className="cost-details__header-charge text-right">
            <FormattedMessage id="general.quoted" defaultMessage="Quoted" />
          </td>
          <td className="cost-details__header-charge text-right">
            <FormattedMessage id="general.quoted" defaultMessage="Quoted" /> ({postBookingCharges?.[0]?.target_currency_code}
            )
          </td>
        </tr>
      </thead>
      <tbody>
        {Object.keys(post_booking_in_transit_costs_data || {}).map(
          (key) =>
            post_booking_in_transit_costs_data?.[key]?.length > 0 && (
              <React.Fragment key={key}>
                <tr>
                  <th colSpan={3} className="cost-details__group">
                    {key}:
                  </th>
                </tr>
                {post_booking_in_transit_costs_data?.[key]?.map((costData: CostDetailCharge) => (
                  <tr key={costData.id} style={{ height: "25px" }}>
                    <td className="cost-details__charge">
                      {costData.additional_cost_description || costData.description}{" "}
                      {costData.approved_by_shipper && <span className="font-weight-bold">(Approved)</span>}
                    </td>
                    <td className="cost-details__charge text-right">{`${formatPriceV2(costData.amount_origin)} ${
                      costData.currency_origin
                    }`}</td>
                    <td className="cost-details__charge text-right">{`${formatPriceV2(costData.amount_target)} ${
                      costData.target_currency_code
                    }`}</td>
                  </tr>
                ))}
              </React.Fragment>
            ),
        )}

        <tr style={{ height: "30px" }} />
      </tbody>
    </>
  );
}

PostBookingConstDetails.propTypes = {
  costDetailsData: PropTypes.instanceOf(Object).isRequired,
};

export default PostBookingConstDetails;
